import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BreadCrumb = _resolveComponent("BreadCrumb");
    const _component_VabeneAddNotification = _resolveComponent("VabeneAddNotification");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.action === 'add')
            ? (_openBlock(), _createBlock(_component_BreadCrumb, {
                key: 0,
                PageTitle: _ctx.$t('pages.sendNotification')
            }, null, 8, ["PageTitle"]))
            : (_openBlock(), _createBlock(_component_BreadCrumb, {
                key: 1,
                PageTitle: _ctx.$t('pages.notificationDetails')
            }, null, 8, ["PageTitle"])),
        _createVNode(_component_VabeneAddNotification, {
            action: _ctx.action ?? 'add',
            notificationID: _ctx.notificationID ?? ''
        }, null, 8, ["action", "notificationID"])
    ], 64));
}
